import { t } from '!/i18n'
import { getLabelPriceForPurchasedItem } from '@/tools/content'
import {
  type FormattedPriceSettings,
  type PurchaseInfo,
} from '@setplex/tria-api'
import type { SseIds } from '~/features/payment/sse-purchases'

export const getLabelPrice = ({
  purchaseInfo,
  free,
  minCurrency,
  minPrice,
}: {
  purchaseInfo?: PurchaseInfo
  free?: boolean
  minCurrency?: string
  minPrice?: number
}): string => {
  if (free) return ''

  if (purchaseInfo) return getLabelPriceForPurchasedItem({ purchaseInfo }) || ''

  if (minCurrency && minPrice) return t('price', { minCurrency, minPrice })

  return ''
}

type CheckPaymentItem =
  | {
      purchaseInfo?: PurchaseInfo
      id?: number
    }
  | null
  | undefined

export const checkBundlePurchase = ({
  item,
  priceSettings,
  bundleIds,
}: {
  item: CheckPaymentItem
  priceSettings: FormattedPriceSettings[]
  bundleIds: SseIds
}) => {
  if (!item || item.purchaseInfo) return false

  return priceSettings.some(
    (priceSetting) =>
      priceSetting.bundle && bundleIds.has(Number(priceSetting.bundle.id))
  )
}

export const checkUpdatedItemIds = (ids: SseIds) => {
  return (item: CheckPaymentItem) => {
    if (!item || item.purchaseInfo) return false

    return Boolean(item?.id) && ids.has(item?.id!)
  }
}
